import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation updateOfferMutation($input: UpdateOfferInput!) {
    updateOffer(input: $input) {
      offer {
        ...OfferEdit_offer
        ...OfferCell_offer
        store {
          id
        }
      }
      errors {
        key
        messages
      }
    }
  }
`;

const updateOffer = (environment, attributes, args = {}) => {
  const { backgroundImage, ...otherAttributes } = attributes;

  const uploadables = backgroundImage
    ? { offerBackgroundImage: backgroundImage }
    : null;

  return commit(environment, {
    mutation,
    uploadables,
    variables: {
      input: otherAttributes,
    },
    optimisticResponse: {
      updateOffer: {
        offer: otherAttributes,
      },
    },
    ...args,
  });
};

export default updateOffer;
